var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.296348 5.27697L5.52174 0.270325C5.67186 0.122668 5.83592 0.0379028 5.99998 0.0379028C6.16404 0.0379028 6.32729 0.0985787 6.45361 0.220778L11.679 5.22742C11.9413 5.47767 11.9499 5.89297 11.6987 6.15437C11.4491 6.41755 11.032 6.42611 10.7714 6.17402L5.99998 1.62657L1.20389 6.22032C0.944122 6.47241 0.526309 6.46385 0.276661 6.20067C0.0254266 5.94142 0.0339578 5.52579 0.296348 5.27697Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-up.45a7faeadbf3bab341645b34d2197892.svg";